import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { submit } from 'redux-form'
import { Link } from 'react-router-dom'
import HelpIcon from '@material-ui/icons/Help'

import { authorization } from 'Module/Auth/Auth'
import { headerSearchUpdate, headerSearchReset } from 'Reducers/Header/actions'

import { DropdownAvatar } from 'Components/Header/DropdownAvatar'
import { HeaderWrapper } from 'Components/Header/HeaderWrapper'
import HeaderUserInfo from '../../Components/Header/HeaderUserInfo/container/HeaderUserInfo'
import { Modal } from 'Components/Modal'
import { ModalBody } from 'Components/Modal/ModalBody'
import { ModalFooter } from 'Components/Modal/ModalFooter'
import { ModalHeader } from 'Components/Modal/ModalHeader'
import { ModalTitle } from 'Components/Modal/ModalTitle'
import SubmitButton from '../../Components/Form/SubmitButton/index'

// import {PromofyLogoLink} from 'Components/Header/PromofyLogoLink'

// import {SearchInput} from 'Components/Header/SearchInput'
import { TopNavButton } from 'Components/Header/TopNavButton'
import { TopNavButtonsWrapper } from 'Components/Header/TopNavButtonsWrapper'

import AddConversionReportModal from 'Containers/Header/Modals/AddConversionModal'
import AddCodeModal from 'Containers/Header/Modals/AddCodeModal'
import { PATHS } from 'Config/Routing/paths'
import IMAGES from 'Assets/Images'
import { addFlyerCodes } from 'Reducers/Inventory/actions'
import { isSmallScreen } from 'Utils/Misc'
import { openMainSidebar } from 'Reducers/UI/actions'
import HamburgerMenuIcon from 'Components/Icons/HamburgerMenu'
import injectStyles from 'react-jss'
import { Table, Td, Tr } from 'Components/Table'

import { hideReduxModal, showReduxModal } from '../../Reducers/UI/actions'

import { incUIBlockCounter, decBlockCounter } from 'Reducers/UIBlock/actions'
import NotificationCenter from '../../Components/NotificationCenter/container/NotificationCenter'
import AddCsvFlyerCodesModal from './Modals/AddCsvFlyerCodesModal'
import HeaderButton from '../../Components/Header/HeaderButton'
import { faqUrls } from '../../Global/faqUrls'
import { ROLE_ADMIN, ROLE_CITY_MANAGER } from '../../shared/constants'
// import Snowflakes from '../../Components/HolidayDesigns/Snowflakes'

const isMobile = isSmallScreen()

const addConversionFromUrlCampaign = () =>
  new URLSearchParams(location.search).get('addConversions')

const getAddCodesFromUrl = () =>
  new URLSearchParams(location.search).get('addCodes')

const getAddCodesCampaignIdFromUrl = () =>
  new URLSearchParams(location.search).get('campaignId')

const getAddCodesArtworkIdFromUrl = () =>
  new URLSearchParams(location.search).get('artworkId')

const styles = {
  hamburgerIcon: {
    fill: 'white',
    marginTop: 10,
    marginRight: 20,
    float: 'left',
    '@media (max-width:500px)': {
      marginRight: 15,
    },
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
}
const ADD_FLYER_CODES_MODAL_TYPE_ENUM = {
  INPUT: 'INPUT',
  FILE: 'FILE',
}
class UnstyledHeader extends Component {
  state = (() => {
    const addConversionInitialCampaign = addConversionFromUrlCampaign()
    const addCodesParam = getAddCodesFromUrl()
    const addCodesCampaignId = getAddCodesCampaignIdFromUrl()
    const addCodesArtworkId = getAddCodesArtworkIdFromUrl()

    return {
      addCodeFormName: 'addCodeForm',
      addCodeModalShow: addCodesParam !== null,
      addCodeInitialCampaignId: addCodesCampaignId || null,
      addCodeInitialArtworkId: addCodesArtworkId || null,
      modalType: ADD_FLYER_CODES_MODAL_TYPE_ENUM.INPUT,
      addConversionInitialCampaign,
      addConversionModalShow: addConversionInitialCampaign !== null,
      submitting: false,
    }
  })()

  // Note: We now consume add-codes params from within the modal
  // after the prefill has actually been applied.

  consumeAddCodesParams = () => {
    try {
      const url = new URL(window.location.href)
      url.searchParams.delete('addCodes')
      url.searchParams.delete('campaignId')
      url.searchParams.delete('artworkId')
      window.history.replaceState({}, '', url.toString())
    } catch (e) {}
    this.setState({
      addCodeInitialCampaignId: null,
      addCodeInitialArtworkId: null,
    })
  }

  searchHandler = searchValue => this.props.headerSearchUpdate(searchValue)

  renderProfilePicture = () => {
    const { userById } = this.props
    const loggedInUser = authorization.getUser()
    const user = userById.id === loggedInUser.id ? userById : loggedInUser
    return user.profilePicture
      ? `${user.profilePicture}?${user.updatedAt}`
      : IMAGES.sampleAvatar
  }
  openGuidelines = () => {
    const fullURL = window.location.href
    const domain = window.location.protocol + '//' + window.location.host
    const pageURL = fullURL.replace(domain, '')
    const urlWithoutSamePart = pageURL.replace('/dashboard', '')

    const user = authorization.getUser()

    const preparedUrl = urlWithoutSamePart
      .replace(/\/\d+/, '/:id')
      .split('?')[0]

    const defaultLinks = {
      [ROLE_ADMIN]:
        'https://docs.google.com/presentation/d/e/2PACX-1vShl8UPxVDzuAAGBwWoJwZPwk-4OE-yGXGkP_7Qjckr-3QTcT0PjZa1InGxwR3V6ez6-ppahXWH3AKF/pub?start=false&loop=false&delayms=60000',
      [ROLE_CITY_MANAGER]:
        'https://docs.google.com/presentation/d/e/2PACX-1vSw-tPIsiZzQ8nzZpxajL4BkjT0VlRrrf5kSl-yJASXzrSvomdKFGUIEx1BACE2KpMDmQnYIL-stwGF/pub?start=false&loop=false&delayms=60000',
    }

    if (!faqUrls[preparedUrl]) {
      return window.open(defaultLinks[user.role])
    }

    return window.open(faqUrls[preparedUrl])
  }

  render = () => {
    const {
      addConversionModalShow,
      addCodeWarningModel,
      addConversionInitialCampaign,
      addConversionsSuccessModelShow,
    } = this.state

    const { classes, openMainSidebar } = this.props

    return (
      <HeaderWrapper>
        {/* <Snowflakes color={'white'} snowflakeCount={20} /> */}
        {isMobile ? (
          <HamburgerMenuIcon
            width={48}
            height={48}
            onClick={openMainSidebar}
            className={classes.hamburgerIcon}
          />
        ) : null}
        <section>
          <Link to={`${PATHS.main.dashboard}${PATHS.dashboard.profile}`}>
            <DropdownAvatar avatarUrl={this.renderProfilePicture()} />
          </Link>
          <HeaderUserInfo />
        </section>
        <section className={classes.flexContainer}>
          <TopNavButtonsWrapper>
            {!authorization.isClient() &&
              !authorization.isRecruiter() &&
              !authorization.isSpy() && (
                <TopNavButton onClickHandler={this.addCodeModalShow}>
                  Add code
                </TopNavButton>
              )}
            {authorization.isAdmin() && (
              <TopNavButton onClickHandler={this.addConversionReportModalShow}>
                Add report
              </TopNavButton>
            )}
          </TopNavButtonsWrapper>
          {authorization.isCityManager() && !authorization.isSpy() && (
            <NotificationCenter />
          )}
          {(authorization.isAdmin() || authorization.isCityManager()) &&
          !authorization.isSpy() ? (
            <HeaderButton onClick={this.openGuidelines}>
              <HelpIcon style={{ color: '#FFF' }} />
            </HeaderButton>
          ) : null}
        </section>
        {this.state.addCodeModalShow &&
          (this.state.modalType == ADD_FLYER_CODES_MODAL_TYPE_ENUM.INPUT ? (
            <AddCodeModal
              addFlyerCodes={this.props.addFlyerCodes}
              addCodeModalCancel={this.addCodeModalCancel}
              csvModalShow={this.csvModalShow}
              showReduxModal={this.props.showReduxModal}
              hideReduxModal={this.props.hideReduxModal}
              initialCampaignId={this.state.addCodeInitialCampaignId}
              initialArtworkId={this.state.addCodeInitialArtworkId}
              onPrefillApplied={this.consumeAddCodesParams}
            />
          ) : (
            <AddCsvFlyerCodesModal
              csvModalCancel={this.csvModalCancel}
              addFlyerCodes={this.props.addFlyerCodes}
              showReduxModal={this.props.showReduxModal}
              hideReduxModal={this.props.hideReduxModal}
            />
          ))}

        {addConversionModalShow ? (
          <AddConversionReportModal
            initiallySelectedCampaign={addConversionInitialCampaign}
            modalCancelButtonHandler={
              this.addConversionReportModalCancelButtonHandler
            }
            modalShow={addConversionModalShow}
            modalSubmitSuccessHandler={
              this.addConversionReportModalSubmitSuccessHandler
            }
          />
        ) : null}

        {addCodeWarningModel
          ? this.renderAddCodeWarning(
              addCodeWarningModel,
              this.addConversionReportModalHide,
            )
          : null}
        {addConversionsSuccessModelShow
          ? this.renderAddConversionsSuccess()
          : null}
      </HeaderWrapper>
    )
  }

  renderAddCodeWarning = ({ warnResults, allBad }, closeActions) => {
    return (
      <Modal show={true}>
        <ModalHeader>
          <ModalTitle>{allBad ? 'Error' : 'Success (Partial)'}</ModalTitle>
        </ModalHeader>
        <ModalBody>
          {allBad ? (
            <p>
              No results were imported, did you select the correct campaign or
              specify the correct codes?
            </p>
          ) : (
            <Fragment>
              <p>Some results were not imported for the selected campaign:</p>
              <br />
              <div style={{ maxHeight: 300, overflowY: 'auto' }}>
                <Table>
                  <tbody>
                    {warnResults.map(model => {
                      return (
                        <Tr>
                          <Td>{model.flyerCode}</Td>
                          <Td>
                            {model.totalMetricsApplied == 0
                              ? 'No results applied, could not find matching mission'
                              : `Applied ${
                                  model.totalMetricsApplied
                                } results, expected ${
                                  model.expectedTotalMetricsApplied
                                }`}
                          </Td>
                        </Tr>
                      )
                    })}
                  </tbody>
                </Table>
              </div>
            </Fragment>
          )}
        </ModalBody>
        <ModalFooter>
          <SubmitButton
            value="confirm"
            onClick={() => {
              this.setState({ addCodeWarningModel: null })
              if (!allBad) {
                closeActions()
              }
            }}
          />
        </ModalFooter>
      </Modal>
    )
  }

  renderAddConversionsSuccess = () => {
    return (
      <Modal show={true}>
        <ModalHeader>
          <ModalTitle>Success</ModalTitle>
        </ModalHeader>
        <ModalBody>All results were imported.</ModalBody>
        <ModalFooter>
          <SubmitButton
            value="ok"
            onClick={() => window.location.reload(true)}
          />
        </ModalFooter>
      </Modal>
    )
  }

  addCodeModalShow = () => this.setState({ addCodeModalShow: true })
  addCodeModalCancel = () =>
    this.setState({
      addCodeModalShow: false,
      addCodeInitialCampaignId: null,
      addCodeInitialArtworkId: null,
    })
  csvModalShow = () => {
    this.setState({ modalType: ADD_FLYER_CODES_MODAL_TYPE_ENUM.FILE })
  }
  csvModalCancel = () => {
    this.setState({
      addCodeModalShow: false,
      modalType: ADD_FLYER_CODES_MODAL_TYPE_ENUM.INPUT,
      addCodeInitialCampaignId: null,
      addCodeInitialArtworkId: null,
    })
  }

  addConversionReportModalShow = () =>
    this.setState({ addConversionModalShow: true })

  addConversionReportModalHide = () =>
    this.setState({ addConversionModalShow: false })

  addConversionReportModalSubmitSuccessHandler = results => {
    // Loop through the results and warn the user about any results that weren't
    // applied
    const inputs = results.inputs.filter(item => item['flyer code'].length > 0)
    const warnResults = inputs
      .map((input, i) => {
        const flyerCode = input['flyer code']
        const expectedTotalMetricsApplied = Object.keys(input).length - 1
        const totalMetricsApplied = results.results.filter(
          item => item.flyerCode === inputs[i]['flyer code'],
        ).length

        if (expectedTotalMetricsApplied - totalMetricsApplied == 0)
          return undefined
        return {
          flyerCode,
          totalMetricsApplied,
          expectedTotalMetricsApplied,
        }
      })
      .filter(m => m)

    if (warnResults.length > 0) {
      return this.setState({
        addCodeWarningModel: {
          allBad: warnResults.length == results.inputs.length,
          warnResults,
        },
      })
    }

    this.setState({
      addConversionInitialCampaign: null,
      addConversionModalShow: false,
      addConversionsSuccessModelShow: true,
    })
  }

  addConversionReportModalCancelButtonHandler = () => {
    this.setState({
      addConversionInitialCampaign: null,
      addConversionModalShow: false,
    })
  }
}

UnstyledHeader.propTypes = {
  headerSearch: PropTypes.string.isRequired,
  headerSearchReset: PropTypes.func.isRequired,
  headerSearchUpdate: PropTypes.func.isRequired,
  submitForm: PropTypes.func.isRequired,
  userById: PropTypes.object.isRequired,
}

const StyledHeader = injectStyles(styles)(UnstyledHeader)

const mapStateToProps = state => ({
  headerSearch: state.header.headerSearch,
  userById: state.users.userById,
  activeCampaignsList: state.campaigns.activeCampaignsList,
  cityPlans: state.campaigns.cityPlansByCampaignIdForFlyerCodesForm,
})

const mapDispatchToProps = dispatch => ({
  headerSearchUpdate: () => dispatch(headerSearchUpdate()),
  headerSearchReset: () => dispatch(headerSearchReset()),
  submitForm: formName => dispatch(submit(formName)),
  addFlyerCodes: async (...args) => {
    dispatch(incUIBlockCounter())
    try {
      const response = await dispatch(addFlyerCodes(...args))
      return response
    } catch (e) {
      throw e
    } finally {
      dispatch(decBlockCounter())
    }
  },
  openMainSidebar: () => dispatch(openMainSidebar()),
  showReduxModal: payload => dispatch(showReduxModal(payload)),
  hideReduxModal: payload => dispatch(hideReduxModal()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(StyledHeader)
